import React, { useState, useEffect, Fragment } from "react";
import { ProductsStyled } from "./styled";
import { API_URL } from "../../utils/Constants";
import {
  CustomBreadcrumb,
  CustomTableFooter,
  MainPageLoader,
} from "../../components";
import { MARKETPLACE_CONSTANTS } from "../../config/constants";
import { getMerchantId, isSessionExpired } from "../../utils/Helper";
import { ApiService } from "../../utils/ApiService";
import { ROUTES } from "../../config/routes";
import { useNavigate } from "react-router-dom";
import ProductAGgrid from "./ProductAGgrid";

const Products = (props) => {
  const [products, setProducts] = useState([]);
  const [loader, setLoader] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const isSchoolAdmin = role === "SCHOOLADMIN";
  const merchantId = getMerchantId();

  useEffect(() => {
    refreshProductList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !loader && refreshProductList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  const refreshProductList = async () => {
    setLoader(true);
    try {
      const url =
        API_URL.PRODUCTS + "?merchantId=" + merchantId + "&pageNumber=" + pageNo + "&pageSize=" + pageSize;
      let headers = {
        "skiply-client": "skiply-portal",
      };
      const response = await ApiService.getRequest(url, headers);
      if (isSessionExpired(response)) {
        navigate(ROUTES.LOGIN);
        return;
      }
      if (response?.status?.code === "Y") {
        let products = response?.body?.products || [];
        setProducts(products);
        if (products.length > 0) setLoader(false);
        setTotalCount(parseInt(response?.body?.totalItems || 0));
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const onPageSizeChanged = (event) => setPageSize(event?.target?.value);

  const onLeftArrow = () => setPageNo(pageNo - 1);

  const onRightArrow = () => setPageNo(pageNo + 1);

  const handleNewProduct = () => {
    localStorage.setItem("productSelected", "");
    localStorage.setItem("productSelectedName", "New product");
    navigate(`${ROUTES.MARKETPLACE}/NewProduct`, 
      {...
          isSchoolAdmin
          ? { state: { fromMerchantDetails: true } }
          : {}
      }
    );
  };

  return (
    <ProductsStyled>
      <CustomBreadcrumb
        isFromMarketplace={true}
        isFromLandingPage={true}
        header={MARKETPLACE_CONSTANTS.PRODUCTS}
        currentPage={MARKETPLACE_CONSTANTS.PRODUCTS}
        isCreateUser={true}
        onCreateUser={handleNewProduct}
      >
        <div className="welcome-page-container">
          {loader ? (
            <MainPageLoader />
          ) : (
            <Fragment>
              <ProductAGgrid studentDetails={products} {...props} />
              <div className="table-footer-container">
                <CustomTableFooter
                  // Offset logic: pageNo - 1 is used to convert 1-based page numbers to 0-based indices.
                  pageNo={Math.max(pageNo - 1, 0)}
                  pageSize={pageSize}
                  totalCount={totalCount}
                  onPageSizeChanged={onPageSizeChanged}
                  onLeftArrow={onLeftArrow}
                  onRightArrow={onRightArrow}
                />
              </div>
            </Fragment>
          )}
        </div>
      </CustomBreadcrumb>
    </ProductsStyled>
  );
};

export default Products;
